import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  crawler: {},
};

export default function crawlPrinceAchievementReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CRAWL_PRINCE_ACHIEVEMENT_REQUEST:
      return {
        ...state,
        loading: true,
        crawler: {},
      };
    case actions.CRAWL_PRINCE_ACHIEVEMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        crawler: action.crawler,
      };
    case actions.CRAWL_PRINCE_ACHIEVEMENT_ERROR:
      return {
        ...state,
        loading: false,
        crawler: {},
      };
    case actions.GET_CRAWL_PRINCE_ACHIEVEMENT_REQUEST:
      return {
        ...state,
        crawler: {},
      };
    case actions.GET_CRAWL_PRINCE_ACHIEVEMENT_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.GET_CRAWL_PRINCE_ACHIEVEMENT_ERROR:
      return {
        ...state,
        crawler: {},
        error: action.error,
      };
    case actions.DOWNLOAD_CRAWL_PRINCE_ACHIEVEMENT_REQUEST:
      return {
        ...state,
      };
    case actions.DOWNLOAD_CRAWL_PRINCE_ACHIEVEMENT_SUCCESS:
      return {
        ...state,
        crawler: action.crawler,
      };
    case actions.DOWNLOAD_CRAWL_PRINCE_ACHIEVEMENT_ERROR:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
